<!--
 * @Author: wangzhu
 * @Date: 2021-12-29 14:51:36
 * @LastEditTime: 2022-12-29 16:06:13
 * @LastEditors: wangzhu10 wangzhu10@jd.com
-->
<template>
    <div id="page3-wrapper">
        <!-- <img class="start-icon animate__animated  animate__pulse animate__infinite" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-52P52winsTkkqhcG48h.png"/> -->
        <!-- <img class="page3-flower" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-14-31wT925dbNQfb25aRK.png"/> -->
        <!-- <img class="page3-title" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-16-09IroyeHnZx79tNeP.png"/> -->
        <img src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-21-19-44xn57fRr44BedswCk6.png" class="start-icon animate__animated  animate__pulse animate__infinite">
        <div class="page3-content">
            <!-- <div class="page-title">好文品鉴</div> -->
            <span v-if="reportData.postNum || reportData.chatNum" class="animate__animated  animate__fadeIn">
                <!-- 今年你在社区阅读文章<span class="report-num"> {{ reportData.viewCount }} </span>篇<br>
                相当于看完<span class="report-num"> {{ books }} </span>本技术书籍<br>
                你最常看的作者是<span class="report-num">{{ reportData.readMaxName }}</span><br>
                你最感兴趣的文章类型是<span class="report-num">{{ reportData.readMaxLabel }}</span><br>
                如果说阅读是获取知识的最佳途径<br>
                那么神灯愿为你照亮技术之路<br> -->
                2023，你在神灯发表的内容<br>
                <template v-if="reportData.readedNum">被阅读<span class="report-num"> {{ reportData.readedNum }} </span>次<br></template>
                <template v-if="reportData.uppedNum">被点赞<span class="report-num"> {{ reportData.uppedNum }} </span>次<br></template>
                <template v-if="reportData.favoredNum">被收藏<span class="report-num"> {{ reportData.favoredNum }} </span>次<br></template>
                <!-- <template v-if="reportData.sharedNum">被转发<span class="report-num"> {{ reportData.sharedNum }} </span>次<br></template> -->
                给你点赞最多的人是<span class="report-num-text"> {{ reportData.userOfMostLikeYou }} </span><br>
                最常浏览你创作的人是<span class="report-num-text"> {{ reportData.userOfMostViewYou }} </span><br>
                热爱与专业的沉淀<br>
                才会引起无数人的共鸣
            </span>
            <span v-else>
                过去一年<br>
                累计<span class="report-num"> {{ reportData.community.totalReadNum }} </span>人次在神灯阅读过文章<br>
                相当于京东所有产研平均读了<span class="report-num"> {{ times }} </span>篇<br>
                为好文点赞<span class="report-num"> 11665 </span>次<br>
                如果说阅读是获取知识的最佳途径<br>
                那么神灯愿为你照亮技术之路
            </span>
            <!-- <div class="sprite"></div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page3',
    props: {
        reportData: {
            required: true,
            default: () => {},
        },
    },
    computed: {
        times() {
            const totalReadNum = this.reportData?.community?.totalReadNum
            if (totalReadNum) {
                return Math.ceil(totalReadNum / 20000);
            }
            return 1;
        },
        books() {
            const count = this.reportData.viewCount
            return count / 20 > 1 ? Math.ceil(count / 20) : (count / 20).toFixed(1)
        }
    },
    methods: {
        handleNext() {
            this.$emit('next');
        },
        handlePre() {
            this.$emit('pre');
        },
    },
};
</script>

<style lang="less" scoped>
#page3-wrapper {
    height: 100vh;
    width: 100%;
    background-image: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-15-53Z8e8nEZOD0sGcmi.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    // padding: 0 20px;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    .page3-content {
        margin: 3.5rem auto 0;
        font-size: 0.4rem;
        // padding: 36px 24px 72px;
        line-height: 2.5;
        width: 65%;
        color: #FAFAD7;
        font-weight: bold;
        // text-shadow: 1px 1px #f4e8e8;
        // background: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-16-09RyvmdMxVqOzKlie.png');
        // background-size: 100% 100%;
        position: relative;
    }
    .page-title {
        width: 100px;
        color: #fff;
        background: #2D97E1;
        border-radius: 4px;
        margin-bottom: 40px;
        font-weight: 500;
        line-height: 1;
        padding: 6px 0;
        position: relative;
        &:after {
            position: absolute;
            display: block;
            content: '';
            width: 300px;
            height: 4px;
            bottom: -4px;
            border-radius: 4px;
            background: #D9F0F9;
        }
    }
    .sprite {
        position: absolute;
        top: 10px;
        left: 150px;
        width: 3.92rem;
        height: 2.5rem;
        background-repeat: no-repeat;
        background-image: url(https://storage.360buyimg.com/iast-agent/reportSprite2.png);
        background-size: 100% 100%;
        -webkit-transform-origin: 0 100%;
        -webkit-animation: hand 1s infinite ease-in-out alternate;
    }
    @keyframes hand {
        0% {
            -webkit-transform: rotate(90deg);
        }
        100% {
            -webkit-transform: rotate(135deg);
        }
    }
    .report-num {
        color: #f1f406;
        font-weight: 500;
        font-size: 0.55rem;
    }
    .report-num-text {
            color: #f1f406;
            font-size: 0.45rem;
            font-weight: 500;
        }
    @keyframes rotoImg{
	from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    } 
	}
    .page3-flower {
        animation: rotoImg 3s linear infinite;
        position: absolute;
        bottom: 36px;
        right: 36px;
        width: 2rem;
        height: 2rem;
    }
    .start-icon {
        position: absolute;
        top: 1.5rem;
        right: 1rem;
        width: 1.2rem;
        height: 1.2rem;
    }
    .page3-title {
        // width: 60%;
        height: 1.5rem;
        margin-top: 2rem;
    }
}
 @media screen and (min-width: 1980px) {
  #page3-wrapper {
    .page3-content {
        margin-top: 25vh;
    }
  }
}
</style>
